const getBulkOrderVisibility = state => state.displayBulkOrders;
const getVendorLookup = state => state.vendorLookup;

export default {
  getBulkOrderVisibility,
  getVendorLookup,
};
